export default __webpack_public_path__ + "static/media/right_1.8b52fa02.png";